<template>
  <div>
    <div class="header-bar">
      <el-button type="primary" @click="showHouseTree()" size="mini">选择项目</el-button>
      <el-button type="primary" @click="search()" size="mini">查询</el-button>
    </div>
    <div class="header">
      <el-descriptions size="mini" :column="2" direction="horizontal" class="custom-descriptions" border :labelStyle="{width: '150px'}">
<!--        <el-descriptions-item label="房产">-->
<!--          {{mainObj.room_name}}-->
<!--        </el-descriptions-item>-->
        <el-descriptions-item label="客户名称">
          <el-input v-model="where.customer_name" placeholder="请输入客户名称" size="mini"></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="房产名称">
          <el-autocomplete size="mini"
                           style="min-width: 400px;max-width: 100%"
                           v-model="mainObj.room_name"
                           :fetch-suggestions="querySearchAsyncRoom"
                           placeholder="请输入房产"
                           popper-class="autocomplete-room"
          ></el-autocomplete>
        </el-descriptions-item>
        <el-descriptions-item label="客户房产关系">
          <el-select size="mini" v-model="where.customer_house_status" filterable clearable multiple :multiple-limit="2" placeholder="请选择客户房产关系" style="width: 348px;">
            <el-option v-for="(item,index) in type_list" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-descriptions-item>

        <el-descriptions-item label="客户信息-完成率区间">
          <el-slider v-model="where.total_score_range" :min="0" :max="100" :step="10" range show-stops style="width: 100%;"></el-slider>
        </el-descriptions-item>
        <el-descriptions-item label="客户类型">
          <el-select v-model="where.customer_type" clearable filterable multiple placeholder="其它类型">
            <el-option label="业主" value="1"></el-option>
            <el-option label="租户" value="2"></el-option>
            <el-option label="住户" value="3"></el-option>
            <el-option label="共有人" value="4"></el-option>
            <el-option label="开发商" value="5"></el-option>
            <el-option label="其它" value="9"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="详细信息-完成率区间">
          <el-slider v-model="where.ext_score_range" :min="0" :max="100" :step="10" range show-stops style="width: 100%;"></el-slider>
        </el-descriptions-item>
        <el-descriptions-item label="房产类型">
          <el-checkbox-group size="mini" v-model="where.house_type" style="width: 100%;" @change="search()">
            <el-checkbox label="1">住宅</el-checkbox>
            <el-checkbox label="4">商铺</el-checkbox>
            <el-checkbox label="5">写字楼</el-checkbox>
            <el-checkbox label="2">车位</el-checkbox>
            <el-checkbox label="3">储藏室</el-checkbox>
          </el-checkbox-group>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <header-tip>
      当前数量： {{pageData.total}}
    </header-tip>
    <div class="content">
      <el-table :data="pageData.data" style="width: 100%" height="calc( 100vh - 400px )" border v-loading="loading" @sort-change="handleSortChange">
        <el-table-column label="ID" prop="id" width="90" fixed></el-table-column>
        <el-table-column label="客户名称" prop="name" width="200">
          <template slot-scope="scope">
            <el-link type="primary" @click="showEditor(scope.row.class, scope.row.id)">{{scope.row.name}}</el-link>
          </template>
        </el-table-column>
        <el-table-column label="客户所属项目" prop="project_name" width="200"></el-table-column>
        <el-table-column label="【客户信息】" prop="total_score" width="150" align="center" sortable="custom">
          <template slot-scope="scope">
            <el-link :type="scope.row.total_score >= 90 ? 'success' : scope.row.total_score >= 60 ? 'warning' : 'danger'">{{scope.row.total_score}}%</el-link>
          </template>
        </el-table-column>
        <el-table-column label="【详细信息】" prop="ext_score" width="150" align="center" sortable="custom">
          <template slot-scope="scope">
            <el-link :type="scope.row.ext_score >= 90 ? 'success' : scope.row.ext_score >= 60 ? 'warning' : 'danger'">{{scope.row.ext_score}}%</el-link>
          </template>
        </el-table-column>
        <el-table-column label="房产名称" prop="house_name" min-width="280"></el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <el-pagination
        layout="prev, pager, next"
        :current-page="pageData.current_page"
        :page-size="pageData.per_page"
        :total="pageData.total"
        @current-change="handleCurrentChange"
      />
    </div>
    <editor v-model="visable" :classValue="classValue" :id="id" @callback="callback(arguments)"></editor>
  </div>
</template>

<script>
import Editor from "../../editor";
import HeaderTip from "../../../Common/header-tip";
export default {
  name: "CustomerCompletenessList",
  components: {HeaderTip, Editor},
  inject: ['mainObj','toggleHouseTree'],
  data(){
    return {
      where: {
        create_time: [],
        operation_type: '',
        sort_field: '',
        order: '',
        house_type: ['1','4','5'],
        customer_house_status:[1,2,3,7],
        customer_type:[],
        total_score_range:[0,100],
        ext_score_range:[0,100],
      },
      loading: false,
      pageData: {
        data: [],
        total: 0,
        current_page: 1,
        per_page: 10,
      },
      classValue: '',
      id: '',
      visable: false,
      type_list:[
        {"id": 1, "name": "业主/租户", "type_id": 15},
        {"id": 2, "name": "业主/历史租户", "type_id": 14},
        {"id": 3, "name": "业主", "type_id": 12},
        {"id": 4, "name": "历史业主/租户", "type_id": 11},
        {"id": 5, "name": "历史业主/历史租户", "type_id": 10},
        {"id": 6, "name": "历史业主", "type_id": 8},
        {"id": 7, "name": "租户", "type_id": 3},
        {"id": 8, "name": "历史租户", "type_id": 2}
      ],
    }
  },
  created() {
    this.getList()
  },
  methods:{
    getList(){
      const that = this
      that.loading=true
      ERP.postRequest({
        url: '/admin/CustomerCompleteness/getCustomerCompletenessList',
        data: {
          ...that.mainObj,
          ...that.where,
          page: this.pageData.current_page,
          limit: this.pageData.per_page,
        }
      },res=>{
        that.loading=false
        if(res.code === 1){
          that.pageData = res.data
        }
      })
    },
    search(){
      this.pageData.current_page=1;
      this.getList()
    },
    handleCurrentChange(currentPage){
      const that=this;
      that.pageData.current_page=currentPage;
      that.getList()
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }

    },
    showHouseTree() {
      this.toggleHouseTree()
    },
    showEditor(_class, id) {
      this.classValue = _class
      this.id = id
      this.visable = true
    },
    callback(arg) {
      this.getList()
      if(arg && arg[0]) this.id = arg[0]
    },
    handleSortChange(sort){
      this.pageData.current_page=1;
      this.where.sort_field=sort.prop;
      this.where.order=sort.order==="descending"? "desc" : "asc";
      this.getList()
    }
  },
}
</script>

<style lang="scss" scoped>
.header{
  /* 样式隔离，只作用于当前组件的 el-descriptions */
  ::v-deep .custom-descriptions {
    width: 100%; /* 确保容器占满父元素宽度 */
  }

  /* 每个描述项平均分配宽度（column=2 则各占 50%） */
  ::v-deep .custom-descriptions .el-descriptions__item {
    width: 50%; /* 100% / column 数量 */
    box-sizing: border-box; /* 包含边框和内边距，避免宽度溢出 */
  }

  /* content 自动填充剩余宽度（描述项宽度 - label 宽度） */
  ::v-deep .custom-descriptions .el-descriptions__content {
    width: calc(100% - 150px); /* 100% 对应描述项宽度，减去 label 的 150px */
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/components/list/CustomerCompletenessList.vue